import { EntitySetName, EntityTypeName, PrCustodyEventEntity } from "@odata/GeneratedEntityTypes";
import { PrSocialEventTypeCode } from "@odata/GeneratedEnums";
import { getEnumNameSpaceName } from "@odata/GeneratedEnums.utils";
import { setDefByEntityType } from "@pages/getDefByEntityType";
import { IDefinition, IGetDefinition } from "@pages/PageUtils";
import CustodyFormView from "@pages/payroll/socialEvents/eventTypes/CustodyFormView";
import { SocialEventGroup } from "@pages/payroll/socialEvents/SocialEvents.types";
import i18next from "i18next";
import { cloneDeep } from "lodash";

import { IAppContext } from "../../../../contexts/appContext/AppContext.types";
import { BasicInputSizes, FieldType } from "../../../../enums";
import { addFormDef, getFormGroup } from "../../../../views/formView/Form.utils";
import { getDefinitions as commonDef, getSocialEventsFormDef } from "../SocialEventsDef";

export const getDefinitions: IGetDefinition = (context: IAppContext): IDefinition => {
    const d = cloneDeep(getSocialEventsFormDef(CustodyFormView, PrSocialEventTypeCode.Custody, context));
    const generalGroup = getFormGroup(d, SocialEventGroup.General);

    addFormDef(d, PrCustodyEventEntity.DateEventStart, {
        type: FieldType.Date,
        width: BasicInputSizes.L,
        label: i18next.t("SocialEvents:Form.DateOfEntry"),
    });

    addFormDef(d, PrCustodyEventEntity.DateEventEnd, {
        type: FieldType.Date,
        isRequired: true,
        width: BasicInputSizes.L,
        label: i18next.t("SocialEvents:Form.ExpectedTermination"),
    });

    generalGroup.rows = [[
        { id: PrCustodyEventEntity.Employee },
        { id: PrCustodyEventEntity.Employment },
    ], [
        { id: PrCustodyEventEntity.DateEventStart },
        { id: PrCustodyEventEntity.DateEventEnd }
    ]];
    
    return {
        ...d,
        entitySet: EntitySetName.PrCustodyEvents
    };
};

getDefinitions.translationFiles = [
    ...commonDef.translationFiles,
    getEnumNameSpaceName(EntityTypeName.PrCustodyEvent)
];
setDefByEntityType(EntityTypeName.PrCustodyEvent, getDefinitions);